import * as React from "react"
import { Box, Skeleton } from "@mui/material"

import { ActionButton, AppTableSeeker } from "@components"
import { usePricingConfigData, usePricingConfigDraft } from "../@hooks"
import { mainSiteFormFilters, mainSitesData } from "../@signals"
import MainSiteDrawer from "./MainSiteDrawer"
import { actionsColumn, marketColumn, siteColumn } from "./columns"


/** Branch 3a: one main site per market — `DIPI_CUSTOMER_MAIN_SITE`.
 *
 * The table's own key is `(id_customer, country)`, so a market has exactly one main site and
 * configuring it again replaces the row. That is why the toolbar says "market", not "row".
 */
export default function ManagementPricingConfigRetailer() {

    const { isLoading } = usePricingConfigData()
    const { stageMainSiteRemoval } = usePricingConfigDraft()

    if (isLoading) return <Skeleton variant="rectangular" height={400} />

    const columns = [
        marketColumn(),
        siteColumn(),
        actionsColumn(stageMainSiteRemoval)
    ]

    return <Box>
        <AppTableSeeker
            data={mainSitesData.value}
            title="Reference retailer per market"
            columns={columns}
            options={{
                viewColumns: false,
                filter: false,
                customToolbar: () => <ActionButton
                    label="Configure market"
                    icon="hexagon-plus"
                    onClick={() => mainSiteFormFilters.value = {
                        country: null,
                        siteID: null,
                        isCreateMode: true
                    }}
                />
            }}
        />

        <MainSiteDrawer />
    </Box>
}
